var _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.855,
    height: 12.188,
    viewBox: "0 0 7.855 12.188",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25546",
    "data-name": "Path 25546",
    d: "M6.11,5.652,8.055,3.384q1.282-1.5,2.563-2.991a.867.867,0,0,1,.8-.345.826.826,0,0,1,.7.541.827.827,0,0,1-.156.89c-.446.527-.9,1.049-1.346,1.573Q8.73,5.259,6.843,7.465a.849.849,0,0,1-.923.356,1.07,1.07,0,0,1-.488-.3Q2.812,4.485.213,1.433A.857.857,0,0,1,.3.213.86.86,0,0,1,1.549.334Q3.756,2.908,5.96,5.484C6,5.535,6.049,5.584,6.11,5.652Z",
    transform: "translate(0 12.188) rotate(-90)",
    fill: "#2555ef"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.1f868130.svg";
export { ForwardRef as ReactComponent };